/* esm.sh - applesauce-common@5.2.0/dist/operations/highlight */
export * from "/*applesauce-common@5.2.0/esnext/dist/operations/highlight.mjs";
